import { produce } from 'immer';
import { each } from 'lodash/fp';
import { GET_ACCESS_CONTROLS } from './types.js';

export const INITIAL_STATE = {
    byEntityId: {}
};

function ensureEntityExists(draft, entityId) {
    if (!draft.byEntityId.hasOwnProperty(entityId)) {
        draft.byEntityId[entityId] = {};
    }
}

function storeEntity(draft, accessControl) {
    ensureEntityExists(draft, accessControl.assetId);

    Object.assign(draft.byEntityId[accessControl.assetId], accessControl);
}

export const accessControlsReducer = produce((draft, action) => {
    switch (action.type) {
        case GET_ACCESS_CONTROLS.SUCCEEDED:
            each(
                (accessControl) => storeEntity(draft, accessControl),
                action.payload.accessControlDtos
            );
            break;
        default:
    }
}, INITIAL_STATE);
